import { styled } from 'styled-components';

import { AnimatedIconHolder } from 'components/AnimatedIcon/AnimatedIcon.styled';
import { colors, h5Text, transition } from 'theme/theme';

export const CmsReactionButtonContainer = styled.div`
  ${AnimatedIconHolder} {
    transform: scale(1.3);
  }

  &[data-qa-reaction-status='INSPIRED'] {
    ${AnimatedIconHolder} {
      position: relative;
      top: 2px;
      left: 2px;
    }
  }
`;

export const CmsReactionTooltipContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
`;

export const CmsReactionTooltipIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CmsReactionTooltipLabel = styled.div<{
  $active?: boolean;
}>`
  opacity: 0;
  transition: opacity ${transition};
  ${(props) => props.$active && `opacity: 1`};
  position: absolute;
  transform: translateY(-48px);
  color: ${colors.lightContentGrey};
  background-color: white;
  font-size: 14px;
  padding: 5px 10px;
  border: 1px solid ${colors.selectionGrey};
  border-radius: 8px;
  pointer-events: none;
`;

export const CmsReactionTooltipIcon = styled.div`
  align-items: center;
  background-color: white;
  border-radius: 9999px;
  cursor: pointer;
  display: flex;
  height: 37px;
  justify-content: center;
  width: 37px;
  transition: transform ${transition};

  &:nth-child(1) {
    transform-origin: right;
  }

  &:nth-child(2) {
    transform-origin: center;
  }

  &:nth-child(3) {
    transform-origin: left;
  }

  &:hover {
    transform: scale(1.3);
  }
`;

export const CmsTotalReactionsHeadingButton = styled.button`
  appearance: none;
  ${h5Text};
  margin: 0;
  cursor: pointer;
`;

export const CmsTotalReactionsHeadingPlaceholder = styled.h5`
  align-items: center;
  display: flex;
  ${h5Text};
  height: 40px;
  margin: 0;
`;
